import { useMemo } from 'react';
import { useAggregationsQuery } from '../../../hooks/useAggregationRequests';
import type { MarketSelectorPreset } from '../types';
import { mapUserAggregationsToMarketSelectorPresets } from './mapUserAggregationsToMarketSelectorPresets';

/** This hook collects and returns all Trading Aggregations mapped as Market Selector Presets to be used in the Market Selector */
export const useMarketSelectorAggregationPresets = () => {
  const aggregationsQuery = useAggregationsQuery();

  const aggregationPresets: MarketSelectorPreset[] | undefined = useMemo(
    () => mapUserAggregationsToMarketSelectorPresets(aggregationsQuery.data),
    [aggregationsQuery.data]
  );

  const aggregationPresetsByID = useMemo(() => {
    return aggregationPresets?.reduce((acc, preset) => {
      acc.set(preset.id, preset);
      return acc;
    }, new Map<string, MarketSelectorPreset>());
  }, [aggregationPresets]);

  return { aggregationPresets, aggregationPresetsByID };
};
